import { createAction, props } from '@ngrx/store';
import { PatientGoal } from '../../models/patient-goal';

export const getPatientGoals = createAction('[Patient Goals] Get Patient Goals');

export const getPatientGoalsSuccess = createAction(
  '[Patient Goals] Get Patient Goals Success',
  props<{ goals: PatientGoal[] }>()
);

export const getPatientGoalsFailure = createAction(
  '[Patient Goals] Get Patient Goals Failure',
  props<{ error: unknown }>()
);

export const getPatientGoalById = createAction('[Patient Goals] Get Patient Goal By Id', props<{ goalId: number }>());

export const getPatientGoalByIdSuccess = createAction(
  '[Patient Goals] Get Patient Goal By Id Success',
  props<{ goal: PatientGoal }>()
);

export const getPatientGoalByIdFailure = createAction(
  '[Patient Goals] Get Patient Goal By Id Failure',
  props<{ error: unknown }>()
);

export const recordPatientGoalPrintEvent = createAction(
  '[Patient Goals] Record Print Event',
  props<{ patientId: number; patientGoalId: number }>()
);

export const recordPatientGoalPrintEventSuccess = createAction('[Patient Goals] Record Print Event Success');

export const recordPatientGoalPrintEventFailure = createAction(
  '[Patient Goals] Record Print Event Failure',
  props<{ error: unknown }>()
);
